import { InferType, mixed, number, object } from 'yup';
import { Nullable } from '../../../model/common';
import { currencyIdSchema, safeString } from './common';

interface PortalFiatDepositSchemaParams {}

export const portalFiatDepositSchema = (params: PortalFiatDepositSchemaParams) => {
    return object({
        currencyId: currencyIdSchema('Deposit Currency cannot be empty!'),
        bankInfoId: object({ label: safeString(), value: number().required('Please select a bank account.') }),
        // amount value must be greater than 0
        amount: safeString().min(0, 'Amount must be more than 0').required('Amount cannot be empty!'),
        requestDescription: safeString(),
        supportingDetails: mixed().optional()
    });
};

export type PortalFiatDepositFormValues = InferType<ReturnType<typeof portalFiatDepositSchema>>;
export type PortalFiatDepositFormInput = Nullable<PortalFiatDepositFormValues>;
